import { setCookie, getCookie } from '../cookies/cookies';

declare global {
    interface Window {
        exponea?: {
            notifications: {
                isAvailable: (callback: (available: boolean) => void) => void;
                isSubscribed: (callback: (subscriptionActive: boolean, notificationsDenied: boolean) => void) => void;
                subscribe: (callback: (status: boolean) => void) => void;
                unsubscribe: (callback: (status: boolean) => void) => void;
            };
            track: any;
        };
    }
}

const bloomreachInit = () => {
    const popup = document.querySelector<HTMLElement>('.push-notification-alert');
    const buttons = document.querySelectorAll<HTMLLinkElement>('.push-notification-alert .subscribe, .notification .unsubscribe');
    const enableButton = document.querySelector<HTMLLinkElement>('.push-notification-alert .subscribe');
    const dismissButton = document.querySelector<HTMLLinkElement>('.push-notification-alert .dismiss');
    const blocked = document.querySelector<HTMLElement>('.push-notification-alert .blocked');

    const COOKIE_NAME = 'notifications-dismissed';
    const COOKIE_EXPIRY_DAYS = 7;

    if (popup) {
        window.exponea.notifications.isAvailable(function (status) {
            if (status) {
                checkPopupVisibility();
                updateStatus();
            }
        });

        enableButton?.addEventListener('click', function (e) {
            e.preventDefault();
            setCookie(COOKIE_NAME, 'true', COOKIE_EXPIRY_DAYS);
            hidePopup();

            window.exponea.notifications.subscribe(function (status) {
                console.log('Subscribed to notifications. Status:', status);
                updateStatus();
            });

            window.exponea.track('consent', {
                action: 'accept',
                category: 'notification',
                valid_until: 'unlimited',
                web_source: 'sgs_web'
            });

        });

        dismissButton?.addEventListener('click', function (e) {
            e.preventDefault();
            setCookie(COOKIE_NAME, 'true', COOKIE_EXPIRY_DAYS);
            hidePopup();
        });
    }

    function hidePopup() {
        popup?.classList.add('hidden');
    }

    function showPopup() {
        popup?.classList.remove('hidden');
    }

    function updateStatus() {
        window.exponea.notifications.isSubscribed(function (subscriptionActive, notificationsDenied) {
            console.log('updating status...', subscriptionActive, notificationsDenied);

            buttons.forEach(function (btn) {
                btn.classList.remove('disabled');
                btn.classList.add('hidden');
            });

            if (subscriptionActive)  hidePopup(); 
            else enableButton?.classList.remove('hidden');

            if (notificationsDenied) {
                buttons.forEach(function (btn) {
                    btn.classList.add('disabled');
                });
                blocked?.classList.remove('hidden');
            }
        });
    }

    function checkPopupVisibility() {
        const cookieExists = getCookie(COOKIE_NAME);
        if (cookieExists) {
            hidePopup(); 
            return;
        }

        window.exponea.notifications.isSubscribed(function (subscriptionActive) {
            if (!subscriptionActive) showPopup();
        });
    }    
};

export default bloomreachInit;